import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgB2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_1904)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.2559 143C39.6693 143 39.1893 142.813 38.8159 142.44C38.4426 142.067 38.2559 141.587 38.2559 141V89C38.2559 88.4133 38.4426 87.9333 38.8159 87.56C39.1893 87.1867 39.6693 87 40.2559 87H64.0159C68.4426 87 72.0693 87.64 74.8959 88.92C77.7226 90.2 79.8026 92.0133 81.1359 94.36C82.5226 96.7067 83.2159 99.4533 83.2159 102.6C83.2159 104.573 82.8426 106.307 82.0959 107.8C81.4026 109.293 80.5226 110.52 79.4559 111.48C78.4426 112.44 77.4559 113.16 76.4959 113.64C78.5759 114.6 80.3893 116.2 81.9359 118.44C83.5359 120.627 84.3359 123.24 84.3359 126.28C84.3359 129.64 83.5893 132.573 82.0959 135.08C80.6026 137.587 78.3893 139.533 75.4559 140.92C72.5226 142.307 68.9493 143 64.7359 143H40.2559ZM50.9759 133.64H63.2159C65.8293 133.64 67.8026 132.92 69.1359 131.48C70.4693 129.987 71.1359 128.227 71.1359 126.2C71.1359 124.12 70.4426 122.387 69.0559 121C67.7226 119.56 65.7759 118.84 63.2159 118.84H50.9759V133.64ZM50.9759 109.64H62.4959C65.0026 109.64 66.8693 109.027 68.0959 107.8C69.3759 106.52 70.0159 104.893 70.0159 102.92C70.0159 100.947 69.3759 99.3733 68.0959 98.2C66.8693 96.9733 65.0026 96.36 62.4959 96.36H50.9759V109.64ZM93.4009 143C92.8143 143 92.3343 142.813 91.9609 142.44C91.5876 142.067 91.4009 141.587 91.4009 141V136.2C91.4009 135.773 91.5076 135.213 91.7209 134.52C91.9876 133.773 92.5476 133.053 93.4009 132.36L103.961 121.88C107.854 118.893 111.001 116.36 113.401 114.28C115.854 112.2 117.668 110.307 118.841 108.6C120.014 106.893 120.601 105.24 120.601 103.64C120.601 101.56 120.014 99.8533 118.841 98.52C117.721 97.1333 115.881 96.44 113.321 96.44C111.614 96.44 110.174 96.8133 109.001 97.56C107.881 98.2533 107.001 99.1867 106.361 100.36C105.721 101.533 105.294 102.813 105.081 104.2C104.921 104.893 104.574 105.373 104.041 105.64C103.561 105.907 103.054 106.04 102.521 106.04H94.0409C93.5076 106.04 93.0809 105.88 92.7609 105.56C92.4409 105.187 92.2809 104.787 92.2809 104.36C92.3343 101.907 92.8409 99.5867 93.8009 97.4C94.8143 95.2133 96.2276 93.2667 98.0409 91.56C99.8543 89.8533 102.041 88.52 104.601 87.56C107.161 86.5467 110.068 86.04 113.321 86.04C117.801 86.04 121.561 86.7867 124.601 88.28C127.641 89.72 129.934 91.72 131.481 94.28C133.028 96.84 133.801 99.8 133.801 103.16C133.801 105.72 133.268 108.093 132.201 110.28C131.188 112.467 129.694 114.573 127.721 116.6C125.748 118.573 123.401 120.627 120.681 122.76L111.241 132.2H133.001C133.588 132.2 134.068 132.387 134.441 132.76C134.814 133.133 135.001 133.613 135.001 134.2V141C135.001 141.587 134.814 142.067 134.441 142.44C134.068 142.813 133.588 143 133.001 143H93.4009Z",
					fill: "#3B2C93"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 132.5,
					cy: 244.5,
					r: 56.5,
					fill: "#BFCEEF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 28.5,
					cy: 19.5,
					r: 56.5,
					fill: "#BFCEEF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_1904",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgB2;
